import React from 'react'
import './MembershipTab.scss'
import { ROUTESLIST } from "@/static/urls";
import { Link } from "react-router-dom";
import { membershipPackages } from "@/utils/constants";

const formatMoney = (n) => (n == null ? "—" : `$${Number(n).toLocaleString()}`);

const MembershipTab = () => {
    const sortedPackages = [...membershipPackages].sort((a, b) => a.order - b.order);
    const comparisonPackages = sortedPackages.filter((p) => !p.excludeFromComparison);

    return (
        <div className="membership-tab">
            {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
            <h3 className="membership-tab__title">💰 Ample Samples Membership vs. Non-Membership Pricing</h3>

            {/* Two cards first (transcript: then table below as reinforcement) */}
            <div className="membership-tab__tiles">
                {sortedPackages.map((pkg) => (
                    <div
                        key={pkg.id}
                        className={[
                            "membership-tile",
                            pkg.hidePrice ? "membership-tile--flexible" : "",
                            pkg.hideSummary ? "membership-tile--cta-pinned" : "",
                        ]
                            .filter(Boolean)
                            .join(" ")}
                    >
                        <div className="membership-tile__content">
                            <div className="membership-tile__header">
                                <h4 className="membership-tile__name">{pkg.name}</h4>
                                {pkg.badge && (
                                    <span className="membership-tile__badge">⭐ {pkg.badge}</span>
                                )}
                            </div>
                            {!pkg.hidePrice && (
                                <div className="membership-tile__price">{formatMoney(pkg.price)}</div>
                            )}
                            <p className="membership-tile__who-label">Who it's for:</p>
                            <p className="membership-tile__description">{pkg.description}</p>
                            <ul className="membership-tile__features">
                                {pkg.features.map((f, i) => (
                                    <li key={i} dangerouslySetInnerHTML={{ __html: f.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") }} />
                                ))}
                            </ul>
                            {pkg.letsTalkTitle && (
                                <>
                                    <p className="membership-tile__lets-talk-title">{pkg.letsTalkTitle}</p>
                                    <p className="membership-tile__lets-talk-body">{pkg.letsTalkBody}</p>
                                </>
                            )}
                            {pkg.note ? <p className="membership-tile__note">{pkg.note}</p> : null}
                        </div>
                        {!pkg.hideSummary && (
                            <div className="membership-tile__summary">
                                <span className="label">Total cost</span>
                                <span className="value">{formatMoney(pkg.totalCost)}</span>
                                <span className="label">Savings</span>
                                <span className="value">{formatMoney(pkg.totalSavings)} saved</span>
                            </div>
                        )}
                        {pkg.ctaMailto ? (
                            <a className="membership-tile__cta" href={`mailto:${pkg.ctaMailto}`}>
                                {pkg.ctaLabel || "Email us"}
                            </a>
                        ) : (
                            <Link
                                className="membership-tile__cta"
                                to={`${ROUTESLIST.CHECKOUT_MEMBERSHIP_IN_PLACE}?tier=${pkg.id === "ample-samples-pro" ? "pro" : "lite"}`}
                            >
                                {pkg.ctaLabel || (pkg.id === "ample-samples-pro" ? "Upgrade to Pro" : "Get Lite membership")}
                            </Link>
                        )}
                    </div>
                ))}
            </div>

            <div className="membership-tab__table-wrap">
                <div className="membership-tab__table-scroll">
                    <table className="membership-tab__table">
                        <thead className="membership-tab__head">
                            <tr>
                                <th className="membership-tab__th">Scenario</th>
                                <th className="membership-tab__th">Membership Fee</th>
                                <th className="membership-tab__th">Cost per Clearance</th>
                                <th className="membership-tab__th"># of Clearances</th>
                                <th className="membership-tab__th">Total Cost</th>
                                <th className="membership-tab__th">Total Savings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comparisonPackages.map((pkg) => (
                                <tr key={pkg.id}>
                                    <td className="membership-tab__td">
                                        <b>{pkg.name}</b>
                                        {pkg.badge && <><br />⭐ {pkg.badge}</>}
                                    </td>
                                    <td className="membership-tab__td">{formatMoney(pkg.membershipFee)}</td>
                                    <td className="membership-tab__td">{formatMoney(pkg.costPerClearance)}</td>
                                    <td className="membership-tab__td">{pkg.numberOfClearances}</td>
                                    <td className="membership-tab__td">
                                        <strong>{formatMoney(pkg.totalCost)}</strong>
                                        <span className="membership-tab__muted">
                                            {" "}( {formatMoney(pkg.membershipFee)} + {formatMoney(pkg.costPerClearance * pkg.numberOfClearances)} )
                                        </span>
                                    </td>
                                    <td className="membership-tab__td"><strong>{formatMoney(pkg.totalSavings)}</strong> saved</td>
                                </tr>
                            ))}
                            <tr>
                                <td className="membership-tab__td">Without Membership</td>
                                <td className="membership-tab__td">—</td>
                                <td className="membership-tab__td">$1,500</td>
                                <td className="membership-tab__td">15</td>
                                <td className="membership-tab__td"><strong>$22,500</strong></td>
                                <td className="membership-tab__td">—</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Mobile Card View – from same data */}
                <div className="membership-mobile-cards">
                    {comparisonPackages.map((pkg) => (
                        <div key={pkg.id} className="membership-card">
                            <div className="membership-card__header">
                                <b>{pkg.name}</b>
                                {pkg.badge && <> ⭐ {pkg.badge}</>}
                            </div>
                            <div className="membership-card__content">
                                <div className="membership-card__row">
                                    <span className="label">Membership Fee</span>
                                    <span className="value">{formatMoney(pkg.membershipFee)}</span>
                                </div>
                                <div className="membership-card__row">
                                    <span className="label">Cost per Clearance</span>
                                    <span className="value">{formatMoney(pkg.costPerClearance)}</span>
                                </div>
                                <div className="membership-card__row">
                                    <span className="label">Number of Clearances</span>
                                    <span className="value">{pkg.numberOfClearances}</span>
                                </div>
                                <div className="membership-card__row">
                                    <span className="label">Total Cost</span>
                                    <span className="value">
                                        <strong>{formatMoney(pkg.totalCost)}</strong>
                                        <span className="membership-tab__muted">
                                            ({formatMoney(pkg.membershipFee)} + {formatMoney(pkg.costPerClearance * pkg.numberOfClearances)})
                                        </span>
                                    </span>
                                </div>
                                <div className="membership-card__row highlight">
                                    <span className="label">Total Savings</span>
                                    <span className="value"><strong>{formatMoney(pkg.totalSavings)}</strong> saved</span>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="membership-card">
                        <div className="membership-card__header">Without Membership</div>
                        <div className="membership-card__content">
                            <div className="membership-card__row">
                                <span className="label">Membership Fee</span>
                                <span className="value">—</span>
                            </div>
                            <div className="membership-card__row">
                                <span className="label">Cost per Clearance</span>
                                <span className="value">$1,500</span>
                            </div>
                            <div className="membership-card__row">
                                <span className="label">Number of Clearances</span>
                                <span className="value">15</span>
                            </div>
                            <div className="membership-card__row">
                                <span className="label">Total Cost</span>
                                <span className="value"><strong>$22,500</strong></span>
                            </div>
                            <div className="membership-card__row">
                                <span className="label">Total Savings</span>
                                <span className="value">—</span>
                            </div>
                        </div>
                    </div>
                </div>

                <h4 className="membership-tab__title">⭐ Best Value: Pro Members clear 3× more songs for only 2× the membership fee.</h4>
            </div>

            <div className="membership-tab__table-wrap">
                <Link className="purchase-button" to={ROUTESLIST.SIGNUP}>
                    Join Now
                </Link>
            </div>
        </div>
    )
}

export default MembershipTab;